import { render, staticRenderFns } from "./ZieleContainer.vue?vue&type=template&id=6b8d0c25&"
import script from "./ZieleContainer.vue?vue&type=script&lang=js&"
export * from "./ZieleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports